import type { ReactNode } from 'react'

type Props = {
  value: string
  onChange: (v: string) => void
}

type Preset = {
  label: string
  rule: string
}

const PRESETS: Preset[] = [
  { label: 'Щомісяця 15-го числа', rule: 'FREQ=MONTHLY;BYMONTHDAY=15' },
  { label: 'Щомісяця останній день', rule: 'FREQ=MONTHLY;BYMONTHDAY=-1' },
  { label: 'Щотижня в понеділок', rule: 'FREQ=WEEKLY;BYDAY=MO' },
  { label: 'Кожні 2 тижні в понеділок', rule: 'FREQ=WEEKLY;INTERVAL=2;BYDAY=MO' },
]

const CUSTOM_VALUE = '__custom__'

export function humanizeRule(rule: string): string {
  const preset = PRESETS.find((p) => p.rule === rule)
  if (preset) return preset.label
  return rule
}

export function RuleBuilder({ value, onChange }: Props) {
  const isPreset = PRESETS.some((p) => p.rule === value)
  const selectValue = isPreset ? value : value ? CUSTOM_VALUE : ''

  const handleSelect = (v: string) => {
    if (v === CUSTOM_VALUE) {
      onChange('')
    } else {
      onChange(v)
    }
  }

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
      <select
        value={selectValue}
        onChange={(e) => handleSelect(e.target.value)}
        className="input"
      >
        <option value="" disabled>
          Оберіть правило…
        </option>
        {PRESETS.map((p) => (
          <option key={p.rule} value={p.rule}>
            {p.label}
          </option>
        ))}
        <option value={CUSTOM_VALUE}>Власне правило (RRULE)</option>
      </select>

      {(!isPreset || selectValue === CUSTOM_VALUE) && (
        <div>
          <textarea
            value={value}
            onChange={(e) => onChange(e.target.value)}
            placeholder="FREQ=MONTHLY;BYMONTHDAY=15"
            className="input"
            rows={2}
            style={{ fontFamily: 'var(--font-mono)', fontSize: 12, resize: 'vertical' }}
          />
          <span style={{ fontSize: 11, color: 'var(--fg-3)' }}>
            Введіть RRULE без префіксу «RRULE:»
          </span>
        </div>
      )}
    </div>
  )
}

export function Field({ label, children }: { label: string; children: ReactNode }) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      <span
        style={{
          fontSize: 11,
          color: 'var(--fg-3)',
          textTransform: 'uppercase',
          letterSpacing: '0.06em',
          fontWeight: 500,
        }}
      >
        {label}
      </span>
      {children}
    </label>
  )
}
